import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Classifier } from '../../../generated/model/classifier';
import { ExactTagsFilter } from '../../../generated/model/exactTagsFilter';
import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import { useOnChange } from '../../../hooks/useOnChange';
import ReadableStatementView from '../../Inputs/ReadableStatementView';
import { InputVersionDropdown } from '../../Inputs/VersionDropdown';

interface Props {
  root?: boolean;
  active: boolean;
  defaultValue?: ExactTagsFilter;
  items: Classifier[];
  readableStatementLabelKey?: string;
  onChange: (value: ExactTagsFilter) => void;
}

const SingleTagFilterInput: React.FC<Props> = React.memo(
  ({ root, active, defaultValue = { value: '' }, items, readableStatementLabelKey, onChange }) => {
    const [state, setState] = useState<any>(defaultValue);
    const { t } = useTranslation();

    useDefaultValueWatcher({ defaultValue, state, setState });
    useOnChange(onChange, state, root);

    const rs: any[] = [];
    if (state.value?.length) {
      rs.push({
        label: readableStatementLabelKey ? t(readableStatementLabelKey) : 'Selected value:',
        value: state.value,
      });
    }
    return (
      <>
        {active ? (
          <div>
            <InputVersionDropdown
              onChange={(value) => {
                setState({ ...state, value: value.version });
              }}
              defaultValue={'' + defaultValue.value!}
              defaultState={{ version: '' + state.value! }}
              items={items}
            />
          </div>
        ) : (
          <ReadableStatementView rows={rs} />
        )}
      </>
    );
  },
);

export default SingleTagFilterInput;
